import React from 'react';
import { Helmet } from 'react-helmet-async';

function Terms() {
  return (
    <>
      <Helmet>
        <title>Terms of Service | FoodLens AI</title>
        <meta name="description" content="FoodLens AI Terms of Service - Review our terms and conditions for using the FoodLens app and services." />
      </Helmet>

      <div className="bg-background min-h-screen">
        {/* Hero */}
        <section className="bg-gradient-hero py-16 md:py-24">
          <div className="section text-center">
            <h1 className="section-heading">Terms of Service</h1>
            <p className="section-subheading mx-auto">
              Our terms and conditions for using FoodLens.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="section py-16">
          <div className="max-w-3xl mx-auto space-y-12">
            {/* Acceptance */}
            <div className="bg-surface rounded-2xl border border-sage-100 p-8">
              <h2 className="font-display text-2xl text-charcoal mb-4">Acceptance of Terms</h2>
              <p className="text-gray-600">
                By using FoodLens, you agree to these Terms of Service. Please read them carefully
                before using our app or website.
              </p>
            </div>

            {/* Legal Information */}
            <div className="bg-sage-100 rounded-2xl p-8">
              <h2 className="font-display text-2xl text-charcoal mb-6">Legal Information</h2>
              <div className="space-y-8">
                <div>
                  <h3 className="font-semibold text-charcoal mb-2">Use License</h3>
                  <p className="text-gray-600">
                    FoodLens grants you a personal, non-transferable license to use the app for your
                    personal, non-commercial purposes.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-charcoal mb-2">Disclaimer</h3>
                  <p className="text-gray-600">
                    The information provided by FoodLens is for general informational purposes only.
                    We make no representation or warranty of any kind regarding the accuracy of the information.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-charcoal mb-2">Limitation of Liability</h3>
                  <p className="text-gray-600">
                    In no event shall FoodLens be liable for any special, direct, indirect, consequential,
                    or incidental damages.
                  </p>
                </div>
              </div>
            </div>

            {/* Subscription Terms */}
            <div className="bg-surface rounded-2xl border border-sage-100 p-8">
              <h2 className="font-display text-2xl text-charcoal mb-6">Subscription Terms</h2>
              <p className="text-gray-600 mb-4">
                FoodLens offers two types of auto-renewable subscriptions:
              </p>
              <ul className="mb-6 space-y-2">
                <li className="flex items-center text-gray-600">
                  <span className="w-2 h-2 bg-sage-500 rounded-full mr-3"></span>
                  <strong>Monthly Plan:</strong>&nbsp;$0.99/month
                </li>
                <li className="flex items-center text-gray-600">
                  <span className="w-2 h-2 bg-sage-500 rounded-full mr-3"></span>
                  <strong>Yearly Plan:</strong>&nbsp;$9.99/year
                </li>
              </ul>
              <div className="space-y-4 text-gray-600">
                <p>
                  Subscriptions will automatically renew unless canceled at least 24 hours before the end
                  of the current period. Payment will be charged to your Apple ID account upon confirmation
                  of purchase. Your account will be charged for renewal within 24 hours prior to the end
                  of the current period.
                </p>
                <p>
                  You can manage or cancel your subscription at any time by going to your App Store
                  account settings after purchase.
                </p>
                <p>
                  All payments are non-refundable. Unused portions of a free trial or current subscription
                  period will not be refunded when canceled.
                </p>
              </div>
            </div>

            {/* Contact */}
            <div className="text-center">
              <p className="text-gray-500 mb-4">Have questions about our terms?</p>
              <a
                href="mailto:foodlens@rainierresearch.xyz"
                className="btn-primary"
              >
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Terms;
